import { render } from "./NEditorParserLocal.vue?vue&type=template&id=1f47e4ce"
import script from "./NEditorParserLocal.vue?vue&type=script&lang=js"
export * from "./NEditorParserLocal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__